import { useState } from "react";
import axios from "axios";
import { getBaseUrlParams } from "../../../utils/getBaseUrlParams";
import { queryParams } from "../../../utils/queryParams";

const graph = axios.create({
  baseURL: queryParams.apiVersion + ""
});

function getGraphParams({ date, moduleView, selectedView, goalData }) {
  const { short_url } = getBaseUrlParams();
  const base = {
    short_url,
    date,
    metric_class_name: goalData.metricType
  };

  if (moduleView === "staff") {
    return {
      ...base,
      goal_store_id: goalData.goalObjectId,
      staff_uid: goalData.staffUid,
      view: selectedView
    };
  }

  return {
    ...base,
    goal_object_id: goalData.goalObjectId
  };
}

async function fetchGraph(params) {
  const apiPath = params.moduleView === "staff" ? "staff_goals" : "goals";
  const finalParams = getGraphParams(params);

  const response = await graph.get(`${apiPath}/visual_graph`, {
    params: finalParams
  });
  return response.data;
}

export function useFetchGraph() {
  const [graphData, setGraphData] = useState(null);
  const [graphLoading, setGraphLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);

  const fetchGraphData = async ({
    date,
    moduleView,
    goalObjectId,
    metricType,
    staffUid,
    selectedView,
    goalData
  }) => {
    if (hasFetched) {
      return;
    }

    setGraphLoading(true);

    try {
      const data = await fetchGraph({
        date,
        moduleView,
        goalObjectId,
        metricType,
        staffUid,
        selectedView,
        goalData
      });
      setGraphData(data);
      setHasFetched(true);
    } catch (err) {
      console.error(err);
    } finally {
      setGraphLoading(false);
    }
  };

  return {
    graphData,
    graphLoading,
    setHasFetched,
    fetchGraphData,
    hasFetched
  };
}
